import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55b63bc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = {
  key: 0,
  class: "row pt-2"
}
const _hoisted_3 = {
  key: 0,
  class: "flex xs8 sm8 lg9"
}
const _hoisted_4 = {
  key: 1,
  class: "row pt-2"
}
const _hoisted_5 = {
  key: 0,
  class: "flex xs8 lg9"
}
const _hoisted_6 = {
  key: 2,
  class: "row pt-2"
}
const _hoisted_7 = {
  key: 3,
  class: "row pt-2"
}
const _hoisted_8 = { class: "flex xs3" }

import { inject, getCurrentInstance, ref, watch, computed } from "vue";

import { userModule } from "@/store/user";
import { Subscription } from "@/models/Subscription";

import Moralis from "moralis";
import { Chain } from "@/models/Contract";
import { NotifiUser } from "@/models/NotifiUser";
import ContractInput from "./contractInput.vue";
import ChainPicker from "./ChainPicker.vue";

/* global defineProps  defineEmits */

export default /*#__PURE__*/_defineComponent({
  props: {
  subscriptionID: { type: String, required: false },
},
  emits: ["changed"],
  async setup(__props, { expose, emit }) {

let __temp: any, __restore: any

const props = __props




const fetching = ref(false);
const activeSubscription = ref<Subscription>();
const fetchBySubscriptionID = async (subID: string): Promise<Subscription> => {
  fetching.value = true;
  const sub = await Subscription.fetch(subID);
  if (sub) {
    activeSubscription.value = sub;
    from_address.value = sub.fromAddress;
    to_address.value = sub.toAddress;
    value.value = sub.value;
    valueOp.value = sub.valueOperator;
    chain.value = sub.get("chain");
    fetching.value = false;
    return sub;
  }
  throw "Invalid Subscription ID";
};

const chain = ref<Chain>("avalanche");
const chkFrom = ref(false);
const newFrom = ref("");
const fromMe = ref(true);
const chkTo = ref(false);
const newTo = ref("");
const toMe = ref(false);
const chkValue = ref(false);
const value = ref(0);
const valueOp = ref("");
const valueOperators = ref(["=", ">", "<"]);
const chkChain = ref(true);

watch(
  value,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (newVal: number, oldVal: number): void => {
    if (newVal && parseFloat(newVal.toString())) {
      chkValue.value = true;
    }
  }
);

/*  watch(subscription,
    (newSub: Subscription, oldSub: Subscription): void => {
      subName.value = newSub.attributes.name;
      newFrom.value = newSub.attributes.fromAddress;
      newTo.value = newSub.attributes.toAddress;
    });
*/
// Should we enable the Value on/off slider?
const allowValue = computed((): boolean => {
  return value.value > 0 && valueOp.value != null;
});
// Are we allowed to enter a Value criteria for the current Subscription Type?
const showValue = computed((): boolean => {
  return true;
});
const showChain = computed((): boolean => {
  return true;
});

const showFrom = computed((): boolean => {
  return true;
});
const myAddresses = computed((): string[] => {
  const user = Moralis.User.current();
  if (user) {
    return user.get("accounts");
  }
  return [];
});
const from_address = computed({
  get: () => {
    if (newFrom.value) {
      return newFrom.value;
    }
    return "";
  },
  set: (newValue: string) => {
    newFrom.value = newValue;
    if (validFrom.value) chkFrom.value = true;
  },
});
const showTo = computed((): boolean => {
  return true;
});
const to_address = computed({
  get: () => {
    if (newTo.value) {
      return newTo.value;
    }
    return "";
  },
  set: (newValue: string) => {
    newTo.value = newValue;
    if (validTo.value) chkTo.value = true;
  },
});
const validTo = computed((): boolean => {
  return (
    to_address.value?.length == 42 && from_address.value !== to_address.value
  );
});
const validFrom = computed((): boolean => {
  return (
    from_address.value?.length == 42 && from_address.value !== to_address.value
  );
});
const validSubmit = computed((): boolean => {
  return validWalletSubmit.value;
});
const validWalletSubmit = computed((): boolean => {
  let dupAddresses = false;
  if (chkTo.value && chkFrom.value) {
    dupAddresses = to_address.value == from_address.value;
  }
  return (
    !dupAddresses &&
    (!chkTo.value || validTo.value) &&
    (!chkFrom.value || validFrom.value) &&
    (!chkValue.value || (valueOp.value != null && value.value > 0)) &&
    chain.value != undefined
  );
});
const message = computed((): string => {
  let msg = "Wallet Transactions";
  if (chkFrom.value) {
    msg = `${msg} <br/>received from <strong>${from_address.value}</strong>`;
  }
  if (chkTo.value) {
    msg = `${msg} <br/>sent to <strong>${to_address.value}</strong>`;
  }
  if (chkValue.value) {
    msg = `${msg} <br/>whose <strong>Value is ${valueOp.value} ${value.value}</strong>`;
  }
  if (chain.value != undefined && msg != "") {
    msg = `${msg} <br/>on the <strong>${chain.value} blockchain</strong>`;
  }
  return msg;
});

const userID = (): string => {
  if (Moralis.User.current()) {
    return Moralis.User.current().id;
  } else {
    console.error("UserID is unset");
    throw "UserID is unset";
  }
};
const setFromAddress = (address: string) => {
  from_address.value = address;
};
const setToAddress = (address: string) => {
  to_address.value = address;
};
const setChain = (c: Chain) => {
  chain.value = c;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const canComplete = computed((): boolean => {
  return true;
});

const irrigate = (s: Subscription): Subscription => {
  if (chkFrom.value) {
    s.set("fromAddress", from_address.value);
  }
  if (chkTo.value) {
    s.set("toAddress", to_address.value);
  }
  if (chkValue.value) {
    s.set("value", `${value.value}`);
    s.set("valueOperator", valueOp.value);
  }
  if (chkChain.value) {
    s.set("chain", chain.value);
  }
  return s;
};

if (props.subscriptionID) {
  (
  ([__temp,__restore] = _withAsyncContext(() => fetchBySubscriptionID(props.subscriptionID))),
  await __temp,
  __restore()
);
}

// eslint-disable-next-line no-undef
expose({ irrigate, message, validSubmit, canComplete });

return (_ctx: any,_cache: any) => {
  const _component_va_switch = _resolveComponent("va-switch")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_checkbox = _resolveComponent("va-checkbox")!
  const _component_va_input = _resolveComponent("va-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(showFrom))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_va_switch, {
            class: "flex xs2 sm2 lg1 pr-3",
            color: "primary",
            disabled: !_unref(validFrom),
            modelValue: chkFrom.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((chkFrom).value = $event))
          }, null, 8, ["disabled", "modelValue"]),
          (!fromMe.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(ContractInput, {
                  label: "From Address",
                  chainPrompt: false,
                  showToken: false,
                  initialAddress: _unref(from_address),
                  addressOptions: _unref(myAddresses),
                  onAddress: setFromAddress
                }, null, 8, ["initialAddress", "addressOptions"])
              ]))
            : _createCommentVNode("", true),
          (fromMe.value)
            ? (_openBlock(), _createBlock(_component_va_select, {
                key: 1,
                class: "flex xs8 sm8 lg9",
                options: _unref(myAddresses),
                label: "From Address",
                modelValue: _unref(from_address),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(from_address) ? (from_address).value = $event : null)),
                success: _unref(validFrom)
              }, null, 8, ["options", "modelValue", "success"]))
            : _createCommentVNode("", true),
          _createVNode(_component_va_checkbox, {
            vlass: "flex xs1 sm1",
            modelValue: fromMe.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fromMe).value = $event)),
            "checked-icon": "person"
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    (_unref(showTo))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_va_switch, {
            class: "flex xs2 lg1 pr-3",
            color: "primary",
            disabled: !_unref(validTo),
            modelValue: chkTo.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((chkTo).value = $event))
          }, null, 8, ["disabled", "modelValue"]),
          (!toMe.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(ContractInput, {
                  label: "To Address",
                  chainPrompt: false,
                  showToken: false,
                  initialAddress: _unref(to_address),
                  addressOptions: _unref(myAddresses),
                  onAddress: setToAddress
                }, null, 8, ["initialAddress", "addressOptions"])
              ]))
            : _createCommentVNode("", true),
          (toMe.value)
            ? (_openBlock(), _createBlock(_component_va_select, {
                key: 1,
                class: "flex xs8 lg9",
                options: _unref(myAddresses),
                label: "To Address",
                modelValue: _unref(to_address),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(to_address) ? (to_address).value = $event : null)),
                success: _unref(validTo)
              }, null, 8, ["options", "modelValue", "success"]))
            : _createCommentVNode("", true),
          _createVNode(_component_va_checkbox, {
            class: "flex xs1",
            modelValue: toMe.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((toMe).value = $event)),
            "checked-icon": "person"
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    (_unref(showValue))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_va_switch, {
            class: "flex xs2 lg1",
            color: "primary",
            disabled: !_unref(allowValue),
            modelValue: chkValue.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((chkValue).value = $event))
          }, null, 8, ["disabled", "modelValue"]),
          _createVNode(_component_va_select, {
            class: "flex xs3 lg4",
            label: "Transaction value is",
            modelValue: valueOp.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((valueOp).value = $event)),
            options: valueOperators.value
          }, null, 8, ["modelValue", "options"]),
          _createVNode(_component_va_input, {
            class: "flex xs5",
            label: "This Value",
            modelValue: value.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((value).value = $event))
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    (_unref(showChain))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_va_switch, {
            class: "flex xs2 lg1",
            color: "primary",
            disabled: true,
            modelValue: chkChain.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((chkChain).value = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(ChainPicker, {
              onSelected: setChain,
              required: ""
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})